import React, { useEffect, ComponentProps } from 'react';
import { isMobileScreen } from '@apply/ui';
import { useAuthentication } from '../../../Login/hooks/useAuthentication';
import { Footer } from '../../../common_v2/components/Footer';
import { Button } from '@apply/components';
import { ApplicationEntryPanel } from './ApplicationEntryPanel';
import { MobileApplicationEntryPanel } from './MobileApplicationEntryPanel';
import { ApplicationCrumbType } from './components/ApplicationEntrySections/types/ApplicationCrumbType';
import { getApplicationCrumbsForLoanType } from './components/ApplicationEntrySections/ApplicationEntrySections';
import { useBorrowerLoanType } from '../../../queries/BorrowerFields/CoreFields';
import { usePrintReady } from '../../hooks/usePrintReady';
import '../../scss/_applicationEntryLayout.scss';

const mobileScreen = isMobileScreen();

type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryV2Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any;
    currentCrumb: ApplicationCrumbType;
    printMode?: boolean;
    saveAndExitButtonProps: ButtonProps;
    nextStepButtonProps: ButtonProps;
    deletePropertyButtonProps?: ButtonProps;
    previousStepButtonVisible?: boolean;
    previousStepButtonClick?: React.MouseEventHandler;
    propertyAddress?: string;
    overrideDefaultContentWidth?: boolean;
}

export const ApplicationEntryLayout: React.FC<ApplicationEntryV2Props> = ({
    children,
    currentCrumb,
    saveAndExitButtonProps,
    nextStepButtonProps,
    deletePropertyButtonProps,
    previousStepButtonVisible = true,
    previousStepButtonClick,
    propertyAddress,
    overrideDefaultContentWidth = false,
    printMode = false,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();
    const [loanType] = useBorrowerLoanType();
    const sections = getApplicationCrumbsForLoanType(loanType);
    const currentSection = sections.find((s) => s.id == currentCrumb)?.number;

    usePrintReady(printMode);

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry'>
                {!mobileScreen && (
                    <ApplicationEntryPanel
                        sections={sections}
                        currentSection={currentSection as number}
                        saveAndExitButtonProps={saveAndExitButtonProps}
                        nextStepButtonProps={nextStepButtonProps}
                        deletePropertyButtonProps={deletePropertyButtonProps}
                        previousStepButtonVisible={previousStepButtonVisible}
                        previousStepButtonClick={previousStepButtonClick}
                        printMode={printMode}
                    >
                        <div className='applicationEntry-child-wrapper'>
                            <div
                                className={
                                    overrideDefaultContentWidth
                                        ? 'applicationEntry-child-width-override'
                                        : 'applicationEntry-child-width'
                                }
                            >
                                {children}
                            </div>
                        </div>
                    </ApplicationEntryPanel>
                )}
                {mobileScreen && (
                    <MobileApplicationEntryPanel
                        sections={sections}
                        currentSection={currentSection as number}
                        saveAndExitButtonProps={saveAndExitButtonProps}
                        nextStepButtonProps={nextStepButtonProps}
                        deletePropertyButtonProps={deletePropertyButtonProps}
                        previousStepButtonVisible={previousStepButtonVisible}
                        previousStepButtonClick={previousStepButtonClick}
                        propertyAddress={propertyAddress}
                        printMode={printMode}
                    >
                        {children}
                    </MobileApplicationEntryPanel>
                )}
            </div>
            {!printMode && <Footer />}
        </>
    );
};
